import { GridColDef } from "@mui/x-data-grid";
import { renderActive } from "../../../../component/list/table-column-renders";

export const columns: GridColDef[] = [
    { field: 'id', headerName: 'Lion ID', flex: 0.5 },
    { field: 'name', headerName: 'Name', flex: 1 },
    { field: 'email', headerName: 'Email', flex: 1 },
    { field: 'active', headerName: 'Active', flex: 0.5, renderCell: (params) => { return renderActive(params.row.active) } }
];